import request from '@/utils/request'

export function getmtrdcomp(bcncd) {
  return request({
    url: `/api/mtrdcomp/${bcncd}`,
    method: 'get',
  })
}

export function getDataBySupplierCd(supplierCd) {
  return request({
    url: `/api/PayCondition`,
    method: 'get',
    params: { bcncd: supplierCd },
  })
}
